// extracted by mini-css-extract-plugin
module.exports = {"container":"EditCompanyUserSkeleton_container__2rn-I","skeletonInput":"EditCompanyUserSkeleton_skeletonInput__1othR"};